import { SnackbarKey } from 'notistack'
import { ENQUEUE_SNACKBAR, CLOSE_SNACKBAR, REMOVE_SNACKBAR, NotificationOptions, SnackbarAction } from '../actions'

export type SnackbarState = {
  notifications: Array<{
    key: SnackbarKey
    message: string
    options?: NotificationOptions
    dismissed?: boolean
  }>
}

export const initialState: SnackbarState = {
  notifications: [],
}

const notifierReducer = (state = initialState, action: SnackbarAction) => {
  switch (action.type) {
    case ENQUEUE_SNACKBAR:
      return {
        ...state,
        notifications: [
          ...state.notifications,
          {
            ...action.notification,
          },
        ],
      }

    case CLOSE_SNACKBAR:
      return {
        ...state,
        notifications: state.notifications.map(notification =>
          action.dismissAll || notification.key === action.key ? { ...notification, dismissed: true } : { ...notification }
        ),
      }

    case REMOVE_SNACKBAR:
      return {
        ...state,
        notifications: state.notifications.filter(notification => notification.key !== action.key),
      }

    default:
      return state
  }
}

export default notifierReducer
